var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contacts"}},[_c('el-tabs',{staticClass:"tabs",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"当前聊天"}},[_c('now-chat')],1),_c('el-tab-pane',{attrs:{"label":"在线"}},[_c('contacts')],1),_c('el-tab-pane',{attrs:{"label":"离线","name":"offLine"}},[_c('off-line-contacts-vue')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }